<template>
  <div class="user-card">
    <div class="link-content">
      <div class="link-logout flex-middle" @click="logout">
        <img :src="require('@/assets/user/loginOut.png')" />
        <!-- <a href="/api/user/logout" @click.self="toLogout">退出</a> -->
        <!-- <div class="logout-btn">{{ $t("user.loginOut") }}</div> -->
      </div>
      <div class="user-avatar-content flex-column flex-middle-only">
        <img v-if="userInfo.id" :src="userInfo.avatar" class="user-avatar" />
        <div
          class="flex-middle-only"
          style="
            font-size: 0.14rem;
            color: #333;
            font-weight: 500;
            margin-left: 0.04rem;
          "
        >
          {{ userInfo.nick_name }}
          <!-- <img class="level-icon" :src="userLevel(userInfo.level)" alt="" /> -->
          <div
            class="level_bg"
            :style="{
              backgroundPosition: `0 -${userInfo.level * 0.44}rem`,
            }"
          ></div>
        </div>
      </div>
      <div class="user-level-progress flex-row flex-middle">
        <div class="level-content">
          Lv-{{ userInfo.level?.toString().padStart(2, "0") }}
        </div>
        <el-progress
          class="flex-1"
          :text-inside="true"
          :stroke-width="15"
          :percentage="percentage || 0"
        ></el-progress>
        <div class="level-content">
          Lv-{{ (userInfo.level + 1).toString().padStart(2, "0") }}
        </div>
      </div>
      <div class="flex-between flex-middle-only my-wallet">
        <span class="my_wallet_text">{{ $t("pc.mybalance") }}</span>
        <div class="flex-middle-only my_kl_yz">
          <img
            style="width: 0.18rem; margin-right: 0.05rem"
            :src="require('@/assets/user/diamond.png')"
            alt=""
          />
          {{ $t("common.diamondText") }}
          {{ $bigNumber(userInfo.diamond / 100) }}
          <span class="line"></span>
          <img
            style="width: 0.18rem; margin-right: 0.05rem"
            :src="require('@/assets/user/gold.png')"
            alt=""
          />
          {{ $t("common.gold") }} {{ $bigNumber(userInfo.gold / 100) }}
        </div>

        <!-- <el-button class="recharge-btn flex-middle" @click="recharge">充值</el-button> -->
      </div>

      <!-- <el-row class="bottom-tab-content flex-middle-only">
        <el-col :span="6">
          <router-link to="/user-center/index" class="flex-column flex-middle">
            <img src="../../assets/img/user-card/mine_nav_ziliao_on.png" />
            <span class="user-size">
              {{ $t("info.userInfo") }}
            </span>
          </router-link>
        </el-col>
        <el-col :span="6">
          <router-link to="/user-center/focus" class="flex-column flex-middle">
            <img src="../../assets/img/user-card/mine_nav_guanzhu_on.png" />
            <span class="user-size">
              {{ $t("user.myFollow") }}
            </span>
          </router-link>
        </el-col>
        <el-col :span="6" class="flex-column flex-middle live" @click.native="startLive()">
          <img :src="isLiving ? require('@/assets/img/user-card/mine_nav_kaibo_on.png') : require('@/assets/img/user-card/mine_nav_kaibo.png')" />
          <span class="user-size">{{ isLiving ? "直播中" : "我要开播" }}</span>
        </el-col>
        <el-col :span="6">
          <router-link to="/user-center/privateChat" class="flex-column flex-middle private">
            <img src="../../assets/img/user-card/private-chat.png" />
            <span class="user-size">聊天消息</span>
            <span class="note" v-show="unreadTotal">{{ unreadTotal }}</span>
          </router-link>
        </el-col>
      </el-row> -->
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { post } from "../../util/http";
import { userLevel } from "@/util/level-icon";
export default {
  props: {
    isLiving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["userInfo"]),
    ...mapGetters(["unreadTotal"]),
    percentage() {
      return this.userInfo.remainder + this.userInfo.process == 0
        ? 0
        : Math.round(
            (
              this.userInfo.process /
              (this.userInfo.remainder + this.userInfo.process)
            ).toFixed(2) * 100
          );
    },
  },
  mounted() {},
  methods: {
    ...mapMutations(["changeUserInfo", "toggleLiveLogout"]),
    ...mapActions(["toLogout"]),
    userLevel,

    recharge() {
      this.$router.push("/user-center/recharge");
    },

    startLive() {
      console.log("startLive");
      this.$emit("startLive");
    },

    async logout() {
      const {
        data: { status },
      } = await post({
        url: "/api/user/logout",
      });
      if (status === 0) {
        // this.$store.commit("setIsLiving", false);
        localStorage.clear();
        // this.changeUserInfo({ id: "", diamond: 0, gold: 0 });
        // this.$router.push({ path: "/" });
        location.reload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-card {
  clear: both;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .link-content {
    display: flex;
    flex-direction: column;
    clear: both;
    width: 100%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 0.05rem;
    position: relative;
  }

  .user-avatar-content {
    margin-top: 0.3rem;
    .level_bg {
      margin-left: 0.1rem;
      background-image: url("~@/assets/user/level_group.png");
      width: 0.44rem;
      height: 0.44rem;
      background-repeat: no-repeat;
      background-size: 0.44rem 5.72rem;
    }
  }

  .user-avatar {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    margin-bottom: 0.1rem;
    background: #d8d8d8;
  }

  .user-level {
    position: relative;
    width: 0.5rem;
    height: 0.16rem;
    border-radius: 0.1rem;
    background-size: 100% 100%;
    color: #fff;
    font-size: 0.12rem;
    padding-right: 0.05rem;
    margin-left: 0.03rem;

    .text {
      background: linear-gradient(
        180deg,
        #ffffff 26.47%,
        rgba(255, 255, 255, 0.75) 76.47%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      text-shadow: 0px 1px 1px rgba(225, 27, 79, 0.1);
      transform: scale(0.8);
    }
  }

  .user-level-progress {
    padding: 0.1rem;

    .level-content {
      padding: 0 0.1rem;
      color: #333333;
      font-size: 0.12rem;
    }
  }

  ::v-deep .el-progress-bar__inner {
    background-image: linear-gradient(90deg, #f76e3e 0%, #e33610 100%);
  }

  .recharge-btn {
    display: block;
    width: 0.48rem;
    height: 0.21rem;
    line-height: 0.21rem;
    overflow: hidden;
    background: #02a8a2;
    color: #fff;
    font-size: 0.12rem;
    border-radius: 0.15rem;
    border: none;
    text-align: center;
  }

  .link-logout {
    position: absolute;
    right: 0.1rem;
    top: 0.2rem;
    cursor: pointer;

    img {
      width: 0.23rem;
      height: 0.23rem;
    }
  }

  .bottom-tab-content {
    background: #f9f9fb;
    border-radius: 0 0 8px 8px;
    height: 0.8rem;
    margin-top: 0.2rem;
    .live {
      cursor: pointer;
    }
    .private {
      position: relative;
      cursor: pointer;
      .note {
        position: absolute;
        top: -0.04rem;
        right: 0.15rem;
        padding: 0 0.05rem;
        min-width: 0.1rem;
        height: 0.2rem;
        line-height: 0.2rem;
        text-align: center;
        border-radius: 0.2rem;
        background: #f64d5c;
        color: #ffffff;
        font-size: 0.12rem;
        margin-left: 0.06rem;
      }
    }

    img {
      width: 0.28rem;
      height: 0.28rem;
      margin-bottom: 0.06rem;
    }
  }

  .line {
    display: inline-block;
    width: 1px;
    height: 0.1rem;
    background: #dbdbdb;
    margin: 0 0.06rem;
  }

  .my-wallet {
    clear: both;
    width: 100%;
    overflow: hidden;
    font-size: 0.14rem;
    padding: 0.2rem;
    color: #333;

    .my_wallet_text {
      flex-shrink: 0;
      display: block;
      width: 0.6rem;
      overflow: hidden;
      font-size: 0.14rem;
    }

    .my_kl_yz {
      width: 100%;
      overflow: hidden;
      font-size: 0.12rem;
      text-align: center;
    }
  }
}
</style>
